var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "30px",
    viewBox: "0 0 37 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 69") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homeowner-mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Onboarding-Step-2",
    transform: "translate(-306.000000, -703.000000)",
    className: "premiumIcon",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-69",
    transform: "translate(306.000000, 703.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9727538,14.7024323 C35.9568355,14.6336811 35.9372436,14.5674299 35.9090804,14.5049288 C35.9005089,14.4799283 35.8858151,14.459928 35.8735702,14.4361776 C35.8490804,14.3861767 35.8221416,14.3349258 35.7915293,14.287425 C35.7719375,14.2599245 35.7498967,14.2374241 35.7290804,14.2111736 C35.6984681,14.1724229 35.6666314,14.1336723 35.6323457,14.0986716 C35.6249987,14.0936715 35.6201008,14.0849214 35.6139783,14.0786713 L20.9201008,0.328429356 C20.4217334,-0.137828847 19.6466314,-0.102828231 19.1898967,0.404680698 C18.733162,0.914689671 18.7662232,1.70470357 19.2658151,2.17096177 L31.6380599,13.7499155 L1.2364273,13.7499155 C0.559284439,13.7499155 0.0119375,14.3099254 0.0119375,14.9999375 C0.0119375,15.6911997 0.559284439,16.2499595 1.2364273,16.2499595 L31.6380599,16.2499595 L19.2658151,27.8289132 C18.7662232,28.2964214 18.733162,29.0864353 19.1898967,29.5951943 C19.4311212,29.865199 19.7617334,30.0002014 20.0935702,30.0002014 C20.3898967,30.0002014 20.6849987,29.8914495 20.9201008,29.6714456 L35.6139783,15.9212037 C35.6201008,15.9149536 35.6249987,15.9087035 35.6323457,15.9012034 C35.6678559,15.8662027 35.6984681,15.8274521 35.7303048,15.7887014 C35.7511212,15.7637009 35.7719375,15.7399505 35.7915293,15.71245 C35.8221416,15.6649492 35.8490804,15.6149483 35.8735702,15.5636974 C35.8858151,15.541197 35.9005089,15.5199466 35.9090804,15.4974462 C35.9372436,15.4336951 35.9568355,15.3649439 35.9727538,15.2961927 C35.9752028,15.2836925 35.9825497,15.2711923 35.9849987,15.256192 C36.0021416,15.1736906 36.0119375,15.087439 36.0119375,14.9999375 C36.0119375,14.912436 36.0021416,14.8261844 35.9849987,14.743683 C35.9825497,14.7299327 35.9752028,14.7174325 35.9727538,14.7024323 Z",
    id: "Fill-329"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow_right.c568d03dbc19c15f8621ef994ab72c71.svg";